import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { filterDefaults } from '../util/filters';
import settings from '../util/config';
const useFiltersStore = create(subscribeWithSelector((set, get) => ({
    ...filterDefaults,
    setQuickMoveIn: (quickMoveIn) => {
        set(() => ({ quickMoveIn: quickMoveIn }));
    },
    resetQuickMoveIn: () => {
        set(() => ({ quickMoveIn: filterDefaults.quickMoveIn, applyFilterFlag: true }));
    },
    setPriceBounds: (priceBounds) => {
        set(() => ({ priceBounds: priceBounds }));
    },
    resetPriceBounds: () => {
        set(() => ({ priceBounds: filterDefaults.priceBounds, applyFilterFlag: true }));
    },
    setBeds: (beds) => {
        set(() => ({ beds: beds }));
    },
    resetBeds: () => {
        set(() => ({ beds: filterDefaults.beds, applyFilterFlag: true }));
    },
    setBaths: (baths) => {
        set(() => ({ baths: baths }));
    },
    resetBaths: () => {
        set(() => ({ baths: filterDefaults.baths, applyFilterFlag: true }));
    },
    setHomeTypes: (homeTypes) => {
        set(() => ({ homeTypes: homeTypes }));
    },
    resetHomeTypes: () => {
        set(() => ({ homeTypes: filterDefaults.homeTypes, applyFilterFlag: true }));
    },
    setSquareFeetBounds: (squareFeetBounds) => {
        set(() => ({ squareFeetBounds: squareFeetBounds }));
    },
    resetSquareFeetBounds: () => {
        set(() => ({ squareFeetBounds: filterDefaults.squareFeetBounds, applyFilterFlag: true }));
    },
    setParkingBays: (parkingBays) => {
        set(() => ({ parkingBays: parkingBays }));
    },
    resetParkingBays: () => {
        set(() => ({ parkingBays: filterDefaults.parkingBays, applyFilterFlag: true }));
    },
    setNumberOfFloors: (numberOfFloors) => {
        set(() => ({ numberOfFloors: numberOfFloors }));
    },
    resetNumberOfFloors: () => {
        set(() => ({ numberOfFloors: filterDefaults.numberOfFloors, applyFilterFlag: true }));
    },
    setLotStatuses: (lotStatuses) => {
        set(() => ({ lotStatuses: lotStatuses, applyFilterFlag: true }));
    },
    resetLotStatuses: () => {
        set(() => ({ lotStatuses: filterDefaults.lotStatuses, applyFilterFlag: true }));
    },
    applyFilterFlag: false,
    setApplyFilterFlag: (applyFilterFlag) => {
        set(() => ({ applyFilterFlag: applyFilterFlag }));
    },
    resetFilters: () => {
        set(() => ({
            ...filterDefaults,
            applyFilterFlag: true
        }));
    },
    getFiltersToStringArray: () => {
        // this will conver the filters to a string array (excludes the lot statuses)
        // with the purpose of sending the data to the print sheet
        const filterStringArray = [];
        const filterState = get();
        if (filterState.quickMoveIn !== filterDefaults.quickMoveIn) {
            filterStringArray.push(settings.QuickMoveInLabel);
        }
        if (filterState.priceBounds !== filterDefaults.priceBounds) {
            filterStringArray.push(`$${filterState.priceBounds.selectedMin} - $${filterState.priceBounds.selectedMax}`);
        }
        if (filterState.beds !== filterDefaults.beds || filterState.baths !== filterDefaults.baths) {
            filterStringArray.push(`${filterState.beds}+${settings.BedsSuffix} / ${filterState.baths}+${settings.BathsSuffix}`);
        }
        if (filterState.homeTypes.length !== 0) {
            filterStringArray.push(filterState.homeTypes.join(', '));
        }
        if (filterState.squareFeetBounds !== filterDefaults.squareFeetBounds) {
            filterStringArray.push(`${filterState.squareFeetBounds.selectedMin} - ${filterState.squareFeetBounds.selectedMax} ${settings.SquareFootageSuffix}`);
        }
        if (filterState.parkingBays !== filterDefaults.parkingBays) {
            filterStringArray.push(`${filterState.parkingBays} ${settings.BaysSuffix}`);
        }
        if (filterState.numberOfFloors !== filterDefaults.numberOfFloors) {
            filterStringArray.push(`${settings.FilterFloorsLabel}: ${filterState.numberOfFloors.label}`);
        }
        return filterStringArray;
    },
    hasNonLotStatusFiltersApplied: () => {
        const state = get();
        return (state.baths !== filterDefaults.baths
            || state.beds !== filterDefaults.beds
            || (state.homeTypes && state.homeTypes.length > 0)
            || state.numberOfFloors !== filterDefaults.numberOfFloors
            || state.parkingBays !== filterDefaults.parkingBays
            || state.priceBounds?.selectedMax !== filterDefaults.priceBounds.selectedMax
            || state.priceBounds?.selectedMin !== filterDefaults.priceBounds.selectedMin
            || state.quickMoveIn !== filterDefaults.quickMoveIn
            || state.squareFeetBounds?.selectedMax !== filterDefaults.squareFeetBounds.selectedMax
            || state.squareFeetBounds?.selectedMin !== filterDefaults.squareFeetBounds.selectedMin);
    }
})));
export default useFiltersStore;
